import styled from '@emotion/styled';

export const ColorRowContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
});
